import { Box, Chip } from "@material-ui/core";
import { IconWarning } from "icons";
import { LOW_MARGIN_THRESHOLD } from "../PricingByClientConst";

const getCellIcon = (pricingData) => {
    if (pricingData.margin !== null && pricingData.margin < LOW_MARGIN_THRESHOLD) {
        return <IconWarning color="red" size={15} />;
    }

    if (pricingData.priceVariance) {
        return <IconWarning color="orange" size={15} />;
    }

    return null;
};

const PricingLotCell = ({ pricingData, classes, onClick }) => {
    if (!pricingData) {
        return <div className={classes.emptyCell}>-</div>;
    }

    return (
        <>
            <Box className={classes.cell} onClick={() => onClick()}>
                {pricingData.isPMFVendor && (
                    <Chip label="PMF" size="small" className={classes.pmfChip} />
                )}
                <span>{pricingData.formattedCharge}</span>
                <span className={classes.cellIcon}>{getCellIcon(pricingData)}</span>
            </Box>
        </>
    );
};

export default PricingLotCell;
